import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { provideNgxMask } from 'ngx-mask';
import { DELIVERIES_ROUTE_PROVIDERS } from './delivery-route.provider';

export const BasePath = new InjectionToken<string[]>('BasePath');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [],
})
export class DeliveryConfigModule {
  static forRoot(basePath: string): ModuleWithProviders<DeliveryConfigModule> {
    return {
      ngModule: DeliveryConfigModule,
      providers: [{ provide: BasePath, useValue: basePath }, DELIVERIES_ROUTE_PROVIDERS, provideNgxMask()],
    };
  }
}
